(function (root, factory) {
  var helpers = factory();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = helpers;
  }

  if (root) {
    root.cartSectionUrl = helpers.cartSectionUrl;
    root.preorderState = helpers.preorderState;
    root.shippingLabel = helpers.shippingLabel;
    root.deliveryMatchLineProperties = helpers.deliveryMatchLineProperties;
    root.deliveryMatchPropertiesFromElement = helpers.deliveryMatchPropertiesFromElement;
    helpers.installPreorderSync(root);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  function cartSectionUrl(sectionId) {
    var routes = typeof window !== 'undefined' && window.Shopify && window.Shopify.routes;
    var storefrontRoot = routes && routes.root ? routes.root : '/';

    if (storefrontRoot.charAt(storefrontRoot.length - 1) !== '/') {
      storefrontRoot += '/';
    }

    return storefrontRoot + 'cart?section_id=' + encodeURIComponent(sectionId);
  }

  function shippingLabel(totalCents, thresholdCents) {
    // Callers map these stable tokens to the existing localized Liquid labels.
    return totalCents >= thresholdCents ? 'free' : 'fallback';
  }

  function nonEmptyString(value) {
    if (value == null) return '';
    var text = String(value).trim();
    return text;
  }

  function deliveryMatchLineProperties(source) {
    var properties = {};
    var levertijd = nonEmptyString(source && source.aangepasteLevertijd);
    var leverdatum = nonEmptyString(source && source.leverdatum);
    var preorder = source && (source.preorder === true || source.preorder === 'true');

    if (levertijd) properties['_aangepaste_levertijd'] = levertijd;
    if (leverdatum) properties['_leverdatum'] = leverdatum;
    if (preorder) properties['_pre-order'] = 'true';

    return properties;
  }

  function deliveryMatchPropertiesFromElement(el) {
    if (!el || !el.dataset) return {};

    return deliveryMatchLineProperties({
      aangepasteLevertijd: el.dataset.aangepasteLevertijd,
      leverdatum: el.dataset.leverdatum,
      preorder: el.dataset.preorder,
    });
  }

  function preorderState(cartItems) {
    var lineFlags = cartItems.map(function (item) {
      return Boolean(item.properties && item.properties['_pre-order'] === 'true');
    });

    return {
      lineFlags: lineFlags,
      cartFlag: lineFlags.some(Boolean) ? 'true' : '',
    };
  }

  function installPreorderSync(browserRoot) {
    if (!browserRoot.fetch || browserRoot.__florafyPreorderSyncInstalled) return;

    var nativeFetch = browserRoot.fetch.bind(browserRoot);
    var syncQueue = Promise.resolve();
    browserRoot.__florafyPreorderSyncInstalled = true;

    function requestUrl(input) {
      return typeof input === 'string' ? input : input && input.url ? input.url : '';
    }

    function isCartMutation(input, init) {
      var method = init && init.method ? init.method : input && input.method;
      var path = requestUrl(input).split('?')[0];

      return String(method || 'GET').toUpperCase() === 'POST'
        && /\/cart\/(add|change|update|clear)\.js$/.test(path);
    }

    async function reconcilePreorderAttribute() {
      var cartResponse = await nativeFetch(cartSectionUrl('').split('?')[0] + '.js', {
        headers: { Accept: 'application/json' },
      });

      if (!cartResponse.ok) throw new Error('Could not read cart after cart mutation');

      var cart = await cartResponse.json();
      var nextFlag = preorderState(cart.items || []).cartFlag;
      var currentFlag = cart.attributes && cart.attributes['Pre-order']
        ? String(cart.attributes['Pre-order'])
        : '';

      if (currentFlag === nextFlag) return;

      var updateResponse = await nativeFetch(cartSectionUrl('').split('?')[0] + '/update.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ attributes: { 'Pre-order': nextFlag } }),
      });

      if (!updateResponse.ok) throw new Error('Could not update pre-order cart attribute');
    }

    browserRoot.syncPreorderCart = function () {
      syncQueue = syncQueue.catch(function () {}).then(reconcilePreorderAttribute);
      return syncQueue;
    };

    browserRoot.fetch = async function (input, init) {
      var response = await nativeFetch(input, init);

      if (response.ok && isCartMutation(input, init)) {
        try {
          await browserRoot.syncPreorderCart();
        } catch (error) {
          // The mutation is committed even when its follow-up attribute write fails.
          var committedError = new Error('Cart mutation succeeded, but pre-order attribute sync failed');
          committedError.cause = error;
          committedError.cartMutationCommitted = true;
          committedError.preorderSyncFailed = true;
          throw committedError;
        }
      }

      return response;
    };
  }

  return {
    cartSectionUrl: cartSectionUrl,
    deliveryMatchLineProperties: deliveryMatchLineProperties,
    deliveryMatchPropertiesFromElement: deliveryMatchPropertiesFromElement,
    installPreorderSync: installPreorderSync,
    preorderState: preorderState,
    shippingLabel: shippingLabel,
  };
});
